import Name from './name';

export default Name;
